import { t } from "@/i18n";
import {
  isAdult,
  isValidAccount,
  isValidCPF,
  isValidEmail,
  isValidInviteCode,
  isValidPassword,
  isValidPhone,
} from "@/lib/validateUtils";

export const validators = {
  email: (value: string) => isValidEmail(value),
  phone: (a_code: string, value: string) => isValidPhone(a_code, value),
  password: (value: string) => isValidPassword(value),
  cpf: (value: string) => isValidCPF(value),
  invite_code: (value: string) => isValidInviteCode(value),
  account: (value: string) => isValidAccount(value),
  a_code: (value: string) => true,
  birth: (value: string) => isAdult(value),
  sex: (value: string) => true,
  contact_phone: (a_code: string, value: string) => isValidPhone(a_code, value),
  contact_email: (value: string) => isValidEmail(value),
  name: (value: string) => true,
  father_surname: (value: string) => true,
  mother_surname: (value: string) => true,
  country: (value: string) => true,
  province: (value: string) => true,
  city: (value: string) => true,
  community: (value: string) => true,
  street: (value: string) => true,
  house_no: (value: string) => true,
  postal_code: (value: string) => true,
  code: (value: string) => true,
};

export const errorMessagesBaseInfo = (field: string) => {
  return {
    email: {
      required: t("auth.emailrequired"),
      invalid: t("auth.emailinvalid"),
    },
    phone: {
      required: t("auth.phonerequired"),
      invalid: t("auth.phoneinvalid"),
    },
    account: {
      required: t("auth.accountrequired"),
      invalid: t("auth.accountinvalid"),
    },
    password: {
      required: t("auth.passwordrequired"),
      invalid: t("auth.passwordinvalid"),
    },
    cpf: {
      required: t("auth.cpfrequired"),
      invalid: t("auth.cpfinvalid"),
    },
    birth: {
      required: t("auth.birthrequired"),
      invalid: t("auth.birthinvalid"),
    },
    invite_code: {
      required: t("auth.invitecoderequired"),
      invalid: t("auth.invitecodeinvalid"),
    },
  }[field];
};

export const errorMessagesPersonProfile = (field: string) => {
  return (
    {
      name: {
        required: t("auth.name_required"),
        invalid: t("auth.name_invalid"),
      },
      father_surname: {
        required: t("auth.father_required"),
        invalid: t("auth.father_invalid"),
      },
      mother_surname: {
        required: t("auth.mother_required"),
        invalid: t("auth.mother_invalid"),
      },
      country: {
        required: t("auth.country_required"),
        invalid: t("auth.country_invalid"),
      },
      province: {
        required: t("auth.province_required"),
        invalid: t("auth.province_invalid"),
      },
      city: {
        required: t("auth.city_required"),
        invalid: t("auth.city_invalid"),
      },
      community: {
        required: t("auth.community_required"),
        invalid: t("auth.community_invalid"),
      },
      street: {
        required: t("auth.street_required"),
        invalid: t("auth.street_invalid"),
      },
      house_no: {
        required: t("auth.house_required"),
        invalid: t("auth.house_invalid"),
      },
      postal_code: {
        required: t("auth.postal_required"),
        invalid: t("auth.postal_invalid"),
      },
      sex: {
        required: t("auth.sex_required"),
        invalid: t("auth.sex_invalid"),
      },
      contact_phone: {
        required: t("auth.contactphone_required"),
        invalid: t("auth.contactphone_invalid"),
      },
      contact_email: {
        required: t("auth.contactemail_required"),
        invalid: t("auth.contactemail_invalid"),
      },
    }[field] ?? {}
  );
};
